const selectAuthenticatedError = state => state.authReducer.get('authenticatedError');

const selectAuthenticatedErrorMessage = state => state.authReducer.get('authenticatedErrorMessage');

const selectIsAuthenticated = state => state.authReducer.get('isAuthenticated');

const selectIsLoading = state => state.authReducer.get('isLoading');

const selectIsWaiting = state => state.authReducer.get('isWaiting');

const selectWebToken = state => state.authReducer.get('webToken');

const selectLogin = state => state.authReducer.get('login');

const selectUserLogged = state => state.authReducer.get('userLogged');

const selectQRCode = state => state.authReducer.get("qrCode");

const selectIsCheckingLogin = state => state.authReducer.get('isCheckingLogin');

export {
	selectAuthenticatedError,
	selectAuthenticatedErrorMessage,
	selectIsAuthenticated,
	selectIsLoading,
	selectLogin,
	selectUserLogged,
	selectIsWaiting,
	selectWebToken,
	selectQRCode,
	selectIsCheckingLogin
};



// WEBPACK FOOTER //
// ./src/state/auth/auth.selectors.js